// TournamentTopHeader
import React, {useEffect, useState} from "react";

import YourPoints from "../../../assets/images/eoro-2024/your-points.svg";
import moment from "moment-timezone";
const TournamentTopHeader = (props) => {
    const {
        isMobile,
        currentMatchDay,
        selectedTab,
        userPoints,
        jackpot,
        showJackpot,
        entries,
    } = props;

    // console.log("selectedTab >>>", selectedTab)
    const [date, setDate] = useState(new Date());
    const [intervalId, setIntervalId] = useState(null);

    useEffect(() => {
        const id = setInterval(() => {
            setDate(new Date().toLocaleString());
        }, 1000);
        setIntervalId(id);
        return () => clearInterval(intervalId);
    }, []);

    // console.log("currentMatchDay on tournament header >>>", currentMatchDay)
    const todayDate = moment().tz("Europe/London").format("YYYY-MM-DDTHH:mm:ss");
    const endDate = moment(currentMatchDay?.start_date).tz("Europe/London").utc().local().format("YYYY-MM-DDTHH:mm:ss");

    const diffTime = moment(endDate).diff(todayDate);
    const duration = moment.duration(diffTime);
    const years = duration.years().toLocaleString(),
        days = String(duration.days().toLocaleString()).padStart(2, "0"),
        months = String(duration.months().toLocaleString()).padStart(2, "0"),
        hrs = String(duration.hours().toLocaleString()).padStart(2, "0"),
        mins = String(duration.minutes().toLocaleString()).padStart(2, "0"),
        secs = String(duration.seconds().toLocaleString()).padStart(2, "0");

    const deadlineReached = (parseInt(months, 10) + parseInt(days, 10) + parseInt(hrs, 10) + parseInt(mins, 10) + parseInt(secs, 10)) <= 0;
    // console.log("deadlineReached >>>", deadlineReached)


    const remainingTime = (value) => {
        return (
            <>
                <div className={`d-flex flex-row align-items-center text-white ${isMobile ?"gap-1":"gap-3"}`}>
                    {
                        months > 0 &&
                        <>
                            <div className={`d-flex flex-column align-items-center bg-skins-red rounded-3 ${isMobile ? "px-1 py-1":" px-2 py-1"}`}>
                                <div className={`bebas fw-bold ${isMobile ? "font-15":"font-28"}`}>{deadlineReached ? "00" : months}</div>
                                <div className={"sfProDisplay font-8 text-upper-case"}>{months === "01" ? "MONTH" : "MONTHS"}</div>
                            </div>
                        </>
                    }
                    <div className={`d-flex flex-column align-items-center bg-skins-red rounded-3 ${isMobile ? "px-1 py-1":" px-2 py-1"}`}>
                        <div className={`bebas fw-bold ${isMobile ? "font-15":"font-28"}`}>{deadlineReached ? "00" : days}</div>
                        <div className={"sfProDisplay font-8 text-upper-case"}>{days === "01" ? "DAY" : "DAYS"}</div>
                    </div>
                    <div className={`d-flex flex-column align-items-center bg-skins-red rounded-3 ${isMobile ? "px-1 py-1":" px-2 py-1"}`}>
                        <div className={`bebas fw-bold ${isMobile ? "font-15":"font-28"}`}>{deadlineReached ? "00" : hrs}</div>
                        <div className={"sfProDisplay font-8 text-upper-case"}>{hrs === "01" ? "HR" : "HRS"}</div>
                    </div>
                    <div className={`d-flex flex-column align-items-center bg-skins-red rounded-3 ${isMobile ? "px-1 py-1":" px-2 py-1"}`}>
                        <div className={`bebas fw-bold ${isMobile ? "font-15":"font-28"}`}>{deadlineReached ? "00" : mins}</div>
                        <div className={"sfProDisplay font-8 text-upper-case"}>{mins === "01" ? "MIN" : "MINS"}</div>
                    </div>
                    <div className={`d-flex flex-column align-items-center bg-skins-red rounded-3 ${isMobile ? "px-1 py-1":" px-2 py-1"}`}>
                        <div className={`bebas fw-bold ${isMobile ? "font-15":"font-28"}`}>{deadlineReached ? "00" : secs}</div>
                        <div className={"sfProDisplay font-8 text-upper-case"}>SECS</div>
                    </div>
                </div>
            </>
        );
    };


    const renderMobile = () => {
        return (
            <>
                <div className={"d-flex flex-row justify-content-between align-items-center mb-2 px-3"}>
                    <div className={"d-flex flex-row gap-2 align-items-start gap-2"}>
                        <img
                            src={YourPoints}
                            // className="img-fluid"
                            alt="points"
                            height={50}
                        />
                        <div className={"d-flex align-items-start justify-content-start flex-column"}>
                            <div className={"fw-600 font-25 bebas text-white"}>{userPoints}</div>
                            <div className={"fw-300 font-10  text-white"}>
                                Points
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-column align-items-center justify-content-center"}>
                        <div className={'fw-600 font-25 text-white bebas text-uppercase'}>
                            <span className={''}>Euro</span> {' '}
                            <span className={'text-skins-teal'}>2024</span>
                        </div>
                        {/*<div className={'fw-bold font-10 text-white cabin text-uppercase'}>*/}
                        {/*    Welcome Back!*/}
                        {/*</div>*/}
                        {
                            selectedTab === 'fixtures' && currentMatchDay && !deadlineReached &&
                            <>
                                <div >
                                    {!deadlineReached && remainingTime(currentMatchDay)}
                                </div>
                            </>
                        }
                    </div>
                    <div className={"d-flex align-items-center justify-content-center flex-column"}>
                        {/*<div className={"fw-600 font-25 text-white bebas"}>£{jackpot}</div>*/}
                        {
                            showJackpot ?
                                <>
                                    <div className={"fw-600 font-25 text-white bebas"}>
                                        {Intl.NumberFormat("en-GB", {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 0,
                                            style: 'currency',
                                            currency: 'GBP'
                                        }).format(parseFloat(jackpot))}
                                    </div>
                                    <div className={"fw-300 font-10  text-white"}>
                                        Jackpot
                                    </div>
                                </>
                                :
                                <>
                                    <div className={"fw-600 font-25 text-white bebas"}>
                                        {entries}
                                    </div>
                                    <div className={"fw-300 font-10  text-white"}>
                                        Entries
                                    </div>
                                </>
                        }

                    </div>
                </div>
                <div className={"skins-red-horizontal-line"}></div>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <div className={"d-flex flex-row justify-content-between align-items-center mb-3"}>
                    <div className={"d-flex flex-row gap-2 align-items-start gap-2 pt-3"}>
                        <img
                            src={YourPoints}
                            className=""
                            alt="points"
                            height={70}
                        />
                        <div className={"d-flex align-items-start justify-content-start flex-column gap-0"}>
                            <div className={"fw-700 font-50 bebas text-white"} style={{lineHeight:"50px"}}>{userPoints}</div>
                            <div className={"fw-400 font-20 text-white"}>
                                Your Points
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-column align-items-center justify-content-center"}>
                        <div className={'fw-600 font-50 text-white bebas text-uppercase'} style={{lineHeight:"55px"}}>
                            <span className={''}>Euro</span> {' '}
                            <span className={'text-skins-teal'}>2024</span>
                        </div>
                        {/*<div className={'fw-bold font-24 text-white cabin text-uppercase'}>*/}
                        {/*    Welcome Back!*/}
                        {/*</div>*/}
                        {
                            selectedTab === 'fixtures' && currentMatchDay && !deadlineReached &&
                            <>
                                <div>
                                    {!deadlineReached && remainingTime(currentMatchDay)}
                                </div>
                            </>
                        }

                    </div>

                    <div className={"d-flex align-items-center justify-content-center flex-column pt-3"}>
                        {
                            showJackpot ?
                                <>
                                    <div className={"fw-600 font-50 text-white bebas"} style={{lineHeight:"50px"}}>{Intl.NumberFormat("en-GB", {
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 0,
                                        style: 'currency',
                                        currency: 'GBP'
                                    }).format(parseFloat(jackpot))}</div>
                                    <div className={"fw-300 font-20  text-white"}>
                                        Jackpot
                                    </div>
                                </>:
                                <>
                                    <div className={"fw-600 font-50 text-white bebas"} style={{lineHeight:"50px"}}>
                                        {entries}
                                    </div>
                                    <div className={"fw-300 font-20  text-white"}>
                                        Entries
                                    </div>
                                </>
                        }

                    </div>
                </div>
                <div className={"skins-red-horizontal-line"}></div>
            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default TournamentTopHeader;
